import { Icon } from '@iconify/react';
import { Seo } from '../lib/seo';
import { useSite } from '../lib/site-context';

export function TermsPage() {
  const { site } = useSite();
  const siteName = site.settings['site.name'] || 'A3GS Tec';

  return (
    <>
      <Seo
        title={`Termos de Uso | ${siteName}`}
        description={`Termos e condições gerais de uso dos serviços e da plataforma ${siteName}.`}
        path="/termos"
      />

      <main className="section">
        <div className="container" style={{ maxWidth: '900px' }}>
          <div className="section-heading" style={{ textAlign: 'left', marginBottom: '32px' }}>
            <span className="section-tag">JURÍDICO & COMPLIANCE</span>
            <h1>Termos de Uso</h1>
            <p>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
          </div>

          <article className="prose-card" style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <section>
              <h2>1. Aceitação dos Termos</h2>
              <p className="muted">
                Ao acessar e utilizar os serviços da <strong>{siteName}</strong>, você concorda expressamente com os
                termos e condições aqui estabelecidos. Caso não concorde com qualquer disposição, solicitamos que não
                utilize nossos serviços ou plataformas digitais.
              </p>
            </section>

            <section>
              <h2>2. Serviços Prestados</h2>
              <p className="muted">
                A <strong>{siteName}</strong> atua no desenvolvimento de software web, infraestrutura de redes,
                gerenciamento de servidores, soluções em nuvem (Cloudflare Edge e banco D1), DNS e segurança da
                informação. As especificações de cada projeto são formalizadas em propostas técnicas e contratos
                específicos.
              </p>
            </section>

            <section>
              <h2>3. Propriedade Intelectual</h2>
              <p className="muted">
                Todo o conteúdo deste site — incluindo logotipos, textos, códigos-fonte, imagens e arquitetura da
                informação — é protegido pelas leis de propriedade intelectual e direitos autorais. É vedada a
                reprodução, distribuição ou engenharia reversa sem prévia autorização por escrito.
              </p>
            </section>

            <section>
              <h2>4. Responsabilidades e Disponibilidade</h2>
              <p className="muted">
                Trabalhamos continuamente para assegurar alta disponibilidade e segurança em nossas aplicações. No
                entanto, não nos responsabilizamos por interrupções temporárias decorrentes de manutenções programadas,
                falhas em provedores externos de telecomunicação ou ataques cibernéticos em larga escala.
              </p>
            </section>

            <section>
              <h2>5. Contato Institucional</h2>
              <p className="muted">
                Dúvidas relacionadas aos presentes termos podem ser encaminhadas diretamente pelo formulário de contato
                ou pelo e-mail oficial: <strong>{site.settings['site.email'] || 'contato@a3gs.com.br'}</strong>.
              </p>
            </section>
          </article>
        </div>
      </main>
    </>
  );
}